// Single source of truth for the deployed navigation build tag. Surfaced in
// the driver home screen footer AND the in-app navigator header so a real-device
// tester can confirm — at a glance, before committing to a drive — that the
// latest navigation code is actually loaded (not a stale cached PWA bundle).
// Bump this string whenever the nav loop changes so the device check stays meaningful.
export const BUILD_TAG = "satnav-beta-2026-06";
